import axios from 'axios';
import { t } from 'i18next';
import { endpoints } from '../../utils/constants';

export const getOrder = (probillNumber, updateState, accountNumbers) =>
  axios.get(`${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.manageOrders.getOrderById}`, {
    params: {
      probillNumber,
    },
    headers: {
      accountNumbers,
    },
  }).then((res) => {
    if (res.status === 200) {
      updateState('data', res.data);
    }
  });

export const uploadFiles = (probillNumber, updateState, accountNumbers, uploadFiles) =>
  axios.post(`${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.manageOrders.uploadFiles}`,
    {
      orderId: probillNumber,
      uploadFiles,
    }).then((res) => {
    if (res.status === 200) {
      updateState('data', res.data);
    }
  });
